// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc3621de","455":"19769c0d"}[chunkId] + ".chunk.js";
};